module.exports = __webpack_public_path__ + "img/placeholder-image.be65927a.jpg";